/** Keep in sync with serverless/common/utils/staffRegistrationRules.ts */
export const isStaffNoPayAttendee = (registration: {
  attendeeType?: string;
}): boolean => String(registration.attendeeType ?? "").trim() === "staff";
